import { create } from 'zustand'

export const useProfileRefresh = create(set => ({
  imageUpdateCounter: 0,
  incrementImageUpdateCounter: () => set((state: { imageUpdateCounter: number }) => ({ imageUpdateCounter: state.imageUpdateCounter + 1 }))
}))
